import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { IDeltaHedgeExeCommonSearchParam } from "../../../Interfaces/deltaHedgeExe";
import { getExeIncrementalChancesTable } from "../../../Requests/deltaHedgeExe";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
}

const ChancesTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, any>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getExeIncrementalChancesTable}
      searchParameters={searchParams}
    />
  );
};

export default ChancesTable;
